import React, {useState, useEffect, useContext} from 'react';
import AdminContext from '../../context/adminContext/adminContext';
import { makeStyles } from '@material-ui/core/styles';
import { Modal,
    Backdrop,
    Fade,
    Button,
    FormControl,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio, 
    Typography
        
        } from '@material-ui/core';


//ESTILOS
const useStyles = makeStyles((theme) => ({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
  
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
    botonera : {
      width:'100%',
      display: 'flex',
      justifyContent:'space-between',
      marginTop:'2rem'
    },
    form : {
      width: '45%',
      marginTop : '.6rem'
    },
    total : {
      display : 'flex',
      justifyContent : 'flex-end',
      alignItems : 'center'
    },
    vista : {
      display : 'flex',
      marginBottom : '2rem',
      justifyContent: 'space-evenly'
    },
    descuentos : {
      display: 'flex',
      flexDirection : 'column',
      width : '45%',
      '& > *': {
        margin: theme.spacing(1)
      }
    }
    
  }));
const ModalMesa = (props) => {
    //EXTRAER PROPS
    const {openModal, mesa , setopenModal,setisloading, setopenTicket, setmesa} = props
    //CONTEXT
    const adminContext = useContext(AdminContext);
    const { finalizarPedido, actualizarPago} = adminContext;
    const classes = useStyles()
    const [pago, setpago] = useState("");
    const [precio, setprecio] = useState(0);
    const [descuento, setdescuento] = useState(null);
    
    useEffect(() => {
      if(mesa){
        if(descuento === null){
          setprecio(mesa.precio_total)
        }else{
          let desc= (mesa.precio_total * descuento) / 100;
          desc.toFixed(2)
          let newPrecio = mesa.precio_total - desc
          setprecio(newPrecio)
        }
        
      }
    
        // eslint-disable-next-line
    }, [descuento, mesa,precio,openModal]);
    //Funciones 
    const handleClose = () => {
        setopenModal(false)
        setprecio(0);
        setpago(null)
        setdescuento(null)
    }
    const handleChange = (e) => {
      setpago(e.target.value);
    }
    const cerrarMesa = async () => {
      if(pago){
          setopenModal(false)
        if(mesa.tipo !== "Salon"){
          //ACTUALIZAR PRECIO Y FORMA DE PAGO
          setisloading(true)
          await actualizarPago(mesa,precio,pago)
          setmesa({
            ...mesa,
            precio_total : precio,
            forma_pago : pago

          })
          setopenTicket(true)
          setisloading(false)
          setprecio(0);
          setpago(null)
          setdescuento(null)
        }else{
         await finalizarPedido(mesa,precio, pago)
        }
      }else{
        return
      }
    }
    const descontar = async (precio) => {
      setdescuento(precio)
    }
    return ( 
      <>
 
        <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={openModal}
     
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openModal}>
    <div className={classes.paper}>
      {mesa ? mesa.tipo === "Salon" ?
      <Typography variant= 'h3' gutterBottom={true}>MESA : {mesa ? mesa.mesa : null}</Typography> 
      : <Typography variant= 'h3' gutterBottom={true}>PEDIDO PARA : {mesa.cliente_manual ? mesa.cliente_manual.nombre : mesa.cliente_registrado.nombre}</Typography> 
      : null}
      
    <div className={classes.vista}>
      <div className={classes.form}>
      <FormControl component="fieldset">
      <FormLabel component="legend">Forma de Pago</FormLabel>
      <RadioGroup aria-label="pago" name="pago" value={pago} onChange={handleChange}>
        <FormControlLabel value="efectivo" control={<Radio />} label="Efectivo" />
        <FormControlLabel value="tarjeta" control={<Radio />} label="Mercado Pago" />
       
      </RadioGroup>
    </FormControl>
      </div>
      <div className={classes.descuentos}>
        <Typography variant='subtitle2' align='center' gutterBottom>Descuentos</Typography>
        <Button variant="contained" color="primary" onClick={() => descontar(10)}>
          10%
        </Button>
        <Button variant="contained" color="primary" onClick={() => descontar(20)}>
          20%
        </Button>
        <Button variant='contained' onClick={()=> descontar(null)}>Cancelar descuento</Button>
      </div>

    </div>
    <div className={classes.total}>
      <Typography>TOTAL :</Typography> <Typography variant='h5'> ${ precio}</Typography>
    </div>
    <div className={classes.botonera}>
                    <Button onClick={()=>{handleClose()}} >Cancelar</Button>
                    <Button onClick={()=>cerrarMesa(precio)} variant="contained" color="primary">Confirmar</Button>
                         </div>  
    </div>
                   </Fade>
        </Modal>
        </>
     );
}
 
export default ModalMesa;